const translations = {
  "en": {
    "Asset": "Asset"
  },
  "zh-tw": {
    "Asset": "資產"
  }
};

export default translations;
